import type { NodeEntry } from '@/types';
import type { JSX, ReactElement, ReactNode } from 'react';
import { getNavbarElement } from './getNavbarElement';
import type { NavbarV2SerializableNode } from './navbarMenuElement';

const serializeNavbarNode = (
  {
    node,
    createKey = (entry) => entry[1].join(','),
    children,
    screen,
  }: {
    node: NavbarV2SerializableNode;
    createKey?: (entry: NodeEntry<NavbarV2SerializableNode>) => string;
    children?: ReactNode;
    screen?: string;
  },
  path = [0], // internal path tracking
): JSX.Element | null => {
  const key = createKey([node, path]);

  const nodeChildren =
    // @ts-ignore
    node.content?.map((n, i) =>
      serializeNavbarNode(
        {
          node: n,
          createKey,
          screen,
        },
        [...path, i],
      ),
    ) || [];

  return getNavbarElement({
    node,
    key,
    screen,
    children: [...nodeChildren, children],
  });
};

export function NavbarSerializerV2(props: { node: NavbarV2SerializableNode; screen?: string }): ReactElement {
  return serializeNavbarNode({ node: props.node, screen: props.screen }) as ReactElement;
}
